/* AURA — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.au-reveal:not(.au-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('au-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('au-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxEls = [];
  function initParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-au-parallax]'));
    if (!parallaxEls.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-au-parallax')) || 0.1;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (progress * k * -100).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Ritual: imagen fija que cambia con cada paso ---------- */
  function initRitual(root) {
    (root || document).querySelectorAll('[data-au-ritual]').forEach(function (sec) {
      var pasos = sec.querySelectorAll('.au-paso');
      var imgs = sec.querySelectorAll('.au-ritual__marco img');
      var num = sec.querySelector('[data-au-ritual-num]');
      if (!pasos.length) return;
      function activar(i) {
        pasos.forEach(function (p, j) { p.classList.toggle('is-activo', j === i); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-activa', j === i); });
        if (num) num.textContent = String(i + 1).padStart(2, '0');
      }
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) activar(Array.prototype.indexOf.call(pasos, en.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(root) {
    (root || document).querySelectorAll('[data-au-galeria]').forEach(function (g) {
      var grandes = g.querySelectorAll('.au-pdp__principal img');
      var minis = g.querySelectorAll('.au-pdp__mini');
      if (!grandes.length) return;
      var actual = 0;
      function ir(i) {
        actual = (i + grandes.length) % grandes.length;
        grandes.forEach(function (im, j) { im.classList.toggle('is-activa', j === actual); });
        minis.forEach(function (m, j) { m.classList.toggle('is-activa', j === actual); });
      }
      minis.forEach(function (m, j) { m.addEventListener('click', function () { ir(j); }); });
      var prev = g.querySelector('.au-pdp__flecha--prev'), next = g.querySelector('.au-pdp__flecha--next');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      /* deslizar con el dedo */
      var x0 = null, principal = g.querySelector('.au-pdp__principal');
      if (principal) {
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
      g._auIr = function (mediaId) {
        grandes.forEach(function (im, j) { if (im.getAttribute('data-media-id') === String(mediaId)) ir(j); });
      };
    });
  }

  /* ---------- Cantidad ---------- */
  function initCantidad(root) {
    (root || document).querySelectorAll('.au-cantidad').forEach(function (c) {
      var input = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-paso') === '-1' ? -1 : 1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  /* ---------- Variantes ---------- */
  function formatear(cents, formato) {
    formato = formato || ('$' + '{{amount_no_decimals_with_comma_separator}}');
    function sep(n, dec, th, ds) { var p = (n / 100).toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p[0] + (p[1] ? ds + p[1] : ''); }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return sep(cents, 2, ',', '.');
        case 'amount_no_decimals': return sep(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return sep(cents, 0, ' ', ',');
        default: return sep(cents, 0, '.', ',');
      }
    });
  }
  function initVariantes(root) {
    (root || document).querySelectorAll('[data-au-producto]').forEach(function (sec) {
      var json = sec.querySelector('[data-au-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var formato = sec.getAttribute('data-money-format');
      var inputId = sec.querySelectorAll('input[name="id"]');
      var precio = sec.querySelectorAll('[data-au-precio]');
      var antes = sec.querySelectorAll('[data-au-antes]');
      var ahorro = sec.querySelectorAll('[data-au-ahorro]');
      var botones = sec.querySelectorAll('[data-au-add]');
      var txtAgotado = sec.getAttribute('data-txt-agotado') || 'Agotado';
      sec.querySelectorAll('.au-opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          sec.querySelectorAll('.au-opcion').forEach(function (f) {
            var c = f.querySelector('input:checked'); sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) return;
          inputId.forEach(function (i) { i.value = v.id; });
          precio.forEach(function (p) { p.textContent = formatear(v.price, formato); });
          var tieneAntes = v.compare_at_price && v.compare_at_price > v.price;
          antes.forEach(function (a) { a.textContent = tieneAntes ? formatear(v.compare_at_price, formato) : ''; a.hidden = !tieneAntes; });
          ahorro.forEach(function (a) { a.hidden = !tieneAntes; if (tieneAntes) a.textContent = a.getAttribute('data-prefijo') + ' ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; });
          botones.forEach(function (b) {
            b.disabled = !v.available;
            var s = b.querySelector('span');
            if (s) s.textContent = v.available ? b.getAttribute('data-txt') : txtAgotado;
          });
          if (v.featured_media) { var g = sec.querySelector('[data-au-galeria]'); if (g && g._auIr) g._auIr(v.featured_media.id); }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  /* ---------- Añadir al carrito (abre el carrito lateral del tema si existe) ---------- */
  function initCarrito(root) {
    (root || document).querySelectorAll('form[data-au-form]').forEach(function (form) {
      if (form._auListo) return; form._auListo = true;
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('[data-au-add]');
        var err = form.querySelector('.au-error');
        if (err) err.textContent = '';
        if (btn) btn.classList.add('is-loading');
        var fd = new FormData(form);
        if (drawer) {
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
        }
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status && res.status !== 200) {
            if (err) err.textContent = res.description || res.message || 'No se pudo añadir. Inténtalo de nuevo.';
            return;
          }
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          }
        }).catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- Barra de compra fija (móvil) ---------- */
  function initBarraFija() {
    var barra = document.querySelector('.au-barra-fija');
    var ancla = document.querySelector('[data-au-ancla-compra]');
    if (!barra || !ancla || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        barra.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    });
    io.observe(ancla);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () {
      var f = document.querySelector('form[data-au-form] [data-au-add]');
      if (f) f.click();
    });
  }

  function initTodo(root) {
    initReveals(root); initRitual(root); initGaleria(root); initCantidad(root);
    initVariantes(root); initCarrito(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTodo(document); initParallax(); initBarraFija();
  });
  /* Editor de Shopify: re-inicializar al editar una sección */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); initParallax(); });
})();
